import { useQuery } from '@tanstack/react-query';
import { ChevronDown, Check } from 'lucide-react';
import { useState } from 'react';
import { customers } from '@/api/customers';

export interface CustomerFilterDropdownProps {
  value: string | null;
  onChange: (v: string | null) => void;
}

export function CustomerFilterDropdown({ value, onChange }: CustomerFilterDropdownProps) {
  const [open, setOpen] = useState(false);
  const { data } = useQuery({
    queryKey: ['customers-list-for-search'],
    queryFn: () => customers.list({ limit: 500 }),
    staleTime: 60_000,
  });
  const rows = data?.rows ?? [];
  const selected = rows.find((c) => c.id === value);

  return (
    <div className="relative">
      <button
        type="button"
        onClick={() => setOpen(!open)}
        className="inline-flex items-center gap-1 rounded border border-slate-200 bg-white px-2.5 py-1 text-xs text-slate-700 shadow-sm hover:bg-slate-50"
      >
        <span>{selected ? selected.name : 'All customers'}</span>
        <ChevronDown className="h-3 w-3" />
      </button>
      {open && (
        <>
          <div className="fixed inset-0 z-10" onClick={() => setOpen(false)} />
          <div className="absolute left-0 z-20 mt-1 max-h-80 w-64 overflow-y-auto rounded-md border border-slate-200 bg-white py-1 shadow-lg">
            <button
              type="button"
              onClick={() => { onChange(null); setOpen(false); }}
              className="flex w-full items-center justify-between px-3 py-1.5 text-xs hover:bg-slate-50"
            >
              <span>All customers</span>
              {value === null && <Check className="h-3 w-3 text-blue-500" />}
            </button>
            <div className="my-1 border-t border-slate-100" />
            {rows.map((c) => (
              <button
                key={c.id}
                type="button"
                onClick={() => { onChange(c.id); setOpen(false); }}
                className="flex w-full items-center justify-between px-3 py-1.5 text-xs hover:bg-slate-50"
              >
                <span className="truncate">{c.name}</span>
                {value === c.id && <Check className="h-3 w-3 text-blue-500" />}
              </button>
            ))}
          </div>
        </>
      )}
    </div>
  );
}
